import { makeAutoObservable, runInAction, observable, action } from 'mobx';
import { fetchAllMediaByType } from '../../utils/api';
import * as Sentry from '@sentry/react';

export class audienceStore {
  audienceCategories = [];
  selectedAudience = {
    id: null,
    label: null,
    value: '',
  };
  mediaInfo = {};
  markets = [];
  availability = [];

  constructor() {
    makeAutoObservable(this, {
      audienceCategories: observable,
      selectedAudience: observable,
      mediaInfo: observable,
      markets: observable,
      availability: observable,
      getAudienceCategories: action,
      setAudience: action,
    });
  }

  getAudienceCategories = async () => {
    try {
      const result = await fetchAllMediaByType('abdm');
      result?.map((data) => {
        if (!this.audienceCategories.some((el) => el.id === data.id)) {
          runInAction(() => {
            if (data.markets.length < 1) {
              return; // not including audiences with no markets data
            }
            this.audienceCategories.push({
              id: data.id,
              label: data.code,
              value: data.title,
            });
          });
        }
      });

      this.audienceCategories.sort(function (category1, category2) {
        const title1 = category1.value.toLowerCase();
        const title2 = category2.value.toLowerCase();

        // sort in an ascending order
        if (title1 < title2) {
          return -1;
        }
        if (title1 > title2) {
          return 1;
        }
        return 0;
      });

      this.setMediaInfo(result);
    } catch (error) {
      Sentry.captureException(new Error('Error in audienceStore: ' + error));
    }
  };

  setAudience(value) {
    for (let i = 0; i < this.audienceCategories.length; i++) {
      if (this.audienceCategories[i].value === value) {
        (this.selectedAudience.id = this.audienceCategories[i].id),
          (this.selectedAudience.value = value),
          (this.selectedAudience.label = this.audienceCategories[i].label);
      }
    }
    this.setMarkets();
    this.setAvailability();
  }

  setMediaInfo(data) {
    this.mediaInfo = data;
  }

  setMarkets() {
    let filteredRecord = this.mediaInfo.filter((item) => {
      return item.code == this.selectedAudience.label;
    });
    this.markets = filteredRecord[0].markets;
  }

  setAvailability() {
    let filteredRecord = this.mediaInfo.filter((item) => {
      return item.code == this.selectedAudience.label;
    });
    this.availability = filteredRecord[0].availability;
  }
}
